import React from "react";
import {Box, Button} from "@material-ui/core";
import {useSupplier} from "hooks";
import {Currency} from "@evennt-tech/api-v2-core";
import {useMaintenanceModeStore} from "store/general/maintenanceMode.store";
import {useImpersonationBannerStore} from "store/general/impersonationBanner.store";
import {getStripeRedirectUrl, STRIPE_CONNECT_BAR_HEIGHT} from "../../helpers";
import {APP_BAR_HEIGHT} from "../../../AppBar";
import useStyles from "../../styles";

const SupplierBar = () => {
  const classes = useStyles();
  const [supplier] = useSupplier();

  const currency =
    supplier?.supplierCompanyToSuppliers?.[0]?.supplierCompany?.currency;

  const {
    panelHeight,
    shouldShowMaintenanceModeNotification,
  } = useMaintenanceModeStore();
  const bannerHeight = useImpersonationBannerStore(
    (state) => state.bannerHeight
  );

  if (!currency) return null;

  const redirectToStripeCreateAccountPage = async ({
    currency,
  }: {
    currency: Currency;
  }): Promise<void> => {
    try {
      const domain = window.location.origin;
      const redirectUrl = await getStripeRedirectUrl(currency, domain);

      if (redirectUrl) {
        window.location.replace(redirectUrl);
      }
    } catch (error) {
      console.error("Failed to get Stripe redirect URL", error);
    }
  };

  return (
    <Box
      className={classes.bar}
      style={{
        height: STRIPE_CONNECT_BAR_HEIGHT,
        top:
          APP_BAR_HEIGHT +
          bannerHeight +
          (shouldShowMaintenanceModeNotification() ? panelHeight : 0),
      }}
    >
      <Box>Register your Stripe account and connect it to FFAIR.</Box>
      <Button
        onClick={() => redirectToStripeCreateAccountPage({currency})}
        className={classes.connectButton}
      >
        Connect now
      </Button>
    </Box>
  );
};

export default SupplierBar;
